import React, { Suspense, useEffect } from "react";
import { useState } from "react";
import dynamic from "next/dynamic";
import { motion } from "framer-motion"; // Ensure correct import
import Head from "next/head";
import Cookies from "js-cookie";

// import Header from "@/components/header";
//import Hero from "@/components/homes/heroes";

const Hero = dynamic(() => import("@/components/homes/heroes"));

const DetailsCounter = dynamic(() =>
  import("@/components/homes/DetailsCounter")
);

const InstructorSection = dynamic(() =>
  import("@/components/homes/Instructor")
);

const NeedHelp = dynamic(() => import("@/components/homes/needHelp"));

const CategoriesSection = dynamic(() =>
  import("@/components/homes/categories")
);

const CounsellingBody = dynamic(() =>
  import("@/components/homes/CounsellingBody")
);

const NEETRankPredictor = dynamic(() =>
  import("@/components/homes/RankPredict")
);

const WhatStudentSay = dynamic(() =>
  import("@/components/homes/WhatStudentsSays")
);

const LandJob = dynamic(() => import("@/components/homes/LandJob"));

const LearningPath = dynamic(() => import("@/components/homes/LearningPath"));

const NeetScore = dynamic(() => import("@/components/homes/NeetScore"));

const Testimonials = dynamic(() =>
  import("@/components/homes/TestimonialsSection")
);

const LearningSelection = dynamic(
  () => import("@/components/homes/LearningSelection") // completed
);

const HomeFAQs = dynamic(() => import("@/components/homes/HomeFAQ"));

import Preloader from "@/components/common/Preloader";

// Animation variants for different effects
const fadeIn = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const scaleUp = {
  hidden: { scale: 0.8, opacity: 0 },
  visible: { scale: 1, opacity: 1, transition: { duration: 1 } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3, // Stagger animation for child components
    },
  },
};

const MotionDiv = motion.div; // Use motion.div directly

const HomePage = ({ authToken }) => {
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [predictedRanks, setPredictedRanks] = useState([]);

  useEffect(() => {
    if (authToken) {
      Cookies.set("authToken", authToken, {
        domain: ".neetsupport.com",
        path: "/",
        secure: true,
        sameSite: "None",
      });
      // Perform actions with the auth token
    }
  }, [authToken]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      document.title =
        "NEET Counselling 2026 | UG, PG, SS Guidance | NEET Support";

      const metaDescription = document.querySelector(
        'meta[name="description"]'
      );
      if (metaDescription) {
        metaDescription.setAttribute(
          "content",
          "Expert NEET counselling help for 2026. UG, PG & SS guidance with personalized support, timely updates, and expert assistance."
        );
      }

      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute(
          "content",
          "neet 2026,NEET Rank Predictor 2026, neet counselling, neet ug counselling guidance, neet pg counselling, mbbs counselling, neet ug counselling"
        );
      }

      const metaRobots = document.querySelector('meta[name="robots"]');
      if (metaRobots) {
        metaRobots.setAttribute("content", "index, follow");
      }

      const metaOgTitle = document.querySelector('meta[property="og:title"]');
      if (metaOgTitle) {
        metaOgTitle.setAttribute(
          "content",
          "NEET Counselling 2026 | UG & PG Mentorship | NEET Support"
        );
      }

      const metaOgDescription = document.querySelector(
        'meta[property="og:description"]'
      );
      if (metaOgDescription) {
        metaOgDescription.setAttribute(
          "content",
          "Get the best NEET UG & PG counselling for 2026. From choice filling to seat allotment — get expert help to secure your dream medical college with NEET Support."
        );
      }

      const metaOgUrl = document.querySelector('meta[property="og:url"]');
      if (metaOgUrl) {
        metaOgUrl.setAttribute("content", "https://neetsupport.com/");
      }

      const metaOgImage = document.querySelector('meta[property="og:image"]');
      if (metaOgImage) {
        metaOgImage.setAttribute(
          "content",
          "https://neetsupport.com/assets/img/general/neet-support-logo.webp"
        );
      }

      const metaTwitterTitle = document.querySelector(
        'meta[name="twitter:title"]'
      );
      if (metaTwitterTitle) {
        metaTwitterTitle.setAttribute(
          "content",
          "NEET Counselling 2026 | UG & PG Mentorship | NEET Support"
        );
      }

      const metaTwitterDescription = document.querySelector(
        'meta[name="twitter:description"]'
      );
      if (metaTwitterDescription) {
        metaTwitterDescription.setAttribute(
          "content",
          "Get the best NEET UG & PG counselling for 2026. From choice filling to seat allotment — get expert help to secure your dream medical college with NEET Support."
        );
      }

      const metaTwitterImage = document.querySelector(
        'meta[name="twitter:image"]'
      );
      if (metaTwitterImage) {
        metaTwitterImage.setAttribute(
          "content",
          "https://neetsupport.com/assets/img/general/neet-support-logo.webp"
        );
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Head>
        {/* FontAwesome - Defer loading */}

        {/* <link rel="preload" as="image" href="/logo.webp" /> */}

        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta charSet="utf-8" />
        <title>NEET Counselling 2026 | UG & PG Mentorship | NEET Support</title>
        <meta
          name="description"
          content="Get the best NEET UG & PG counselling for 2026. From choice filling to seat allotment — get expert help to secure your dream medical college with NEET Support."
        />
        <meta
          name="keywords"
          content="neet 2026, neet rank predictor, neet counselling, neet ug counselling, Medical Colleges list, ebook, neet support"
        />

        <link rel="canonical" href="https://neetsupport.com/" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="max-image-preview:large" />

        <meta
          property="og:title"
          content="NEET Counselling 2026 | UG & PG Mentorship | NEET Support"
        />
        <meta
          property="og:description"
          content="Get the best NEET UG & PG counselling for 2026. From choice filling to seat allotment — get expert help to secure your dream medical college with NEET Support."
        />
        <meta property="og:url" content="https://neetsupport.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://neetsupport.com/favicon/neetsupport-logo.webp"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="NEET Counselling 2026 | UG & PG Mentorship | NEET Support"
        />
        <meta
          name="twitter:description"
          content="Get the best NEET UG & PG counselling for 2026. From choice filling to seat allotment — get expert help to secure your dream medical college with NEET Support."
        />
        <meta
          name="twitter:image"
          content="https://neetsupport.com/favicon/neetsupport-logo.webp"
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "NEET Support",
            "url": "https://neetsupport.com/",
            "logo": "https://neetsupport.com/favicon/neetsupport-logo.webp",
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "+91-9560465351",
                "contactType": "customer support",
                "areaServed": "IN",
                "availableLanguage": "en"
              }
            ],
            "sameAs": [
              "https://www.instagram.com/neetsupportindia/",
              "https://www.facebook.com/NEETSupport.comINDIA",
              "https://www.linkedin.com/company/neetsupport/",
              "https://www.youtube.com/@NEETSupportIndia"
           ]
          }
        `,
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "NEET Counselling 2026 | UG, PG, SS Guidance | NEET Support",
            "url": "https://www.neetsupport.com",
            "description": "Expert NEET counselling help for 2026. UG, PG & SS guidance with personalized support, timely updates, and expert assistance.",
            "inLanguage": "English",
            "image": {
             "@type": "ImageObject",
             "url": "https://neetsupport.com/favicon/neetsupport-logo.webp"
             },
            "mainEntityOfPage": {
             "@type": "WebPage",
             "@id": "https://www.neetsupport.com"
             },
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://www.neetsupport.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
           }
      }
      `,
          }}
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "NEET Support",
            "url": "https://neetsupport.com/",
            "logo": "https://neetsupport.com/favicon/neetsupport-logo.webp",
            "telephone": "+91-9560465351",
                            "address": [
                  {
                    "@type": "PostalAddress",
                    "name": "Head Office",
                    "streetAddress": "Ground Floor, C-127, C Block, Sector 63",
                    "addressLocality": "Noida",
                    "addressRegion": "Uttar Pradesh",
                    "postalCode": "201301",
                    "addressCountry": "IN"
                  },
                ]
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 28.5002996,
              "longitude": 77.4150482
            },
            "openingHours": "Mo-Sa 09:00-18:00",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9560465351",
              "contactType": "customer support",
              "areaServed": "IN",
              "availableLanguage": ["en", "hi"]
            },
            "sameAs": [
              "https://www.instagram.com/neetsupportindia/",
              "https://www.facebook.com/NEETSupport.comINDIA",
              "https://www.linkedin.com/company/neetsupport/",
              "https://www.youtube.com/@NEETSupportIndia"
              ]
          }
        `,
          }}
        />
      </Head>
      {/* <div className="main-content">
        <Header />
      </div> */}
      <Suspense fallback={<Preloader />}>
        <MotionDiv
          className="content-wrapper js-content-wrapper overflow-hidden"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <MotionDiv variants={fadeIn}>
            <Hero />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <DetailsCounter />
          </MotionDiv>

          <MotionDiv variants={scaleUp}>
            <InstructorSection />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <NeedHelp />
          </MotionDiv>

          <MotionDiv variants={scaleUp}>
            <CategoriesSection />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <CounsellingBody />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <NEETRankPredictor
              setShowLoginPrompt={setShowLoginPrompt}
              setShowLoadingModal={setShowLoadingModal}
              showLoadingModal={showLoadingModal}
              setShowResultModal={setShowResultModal}
              setPredictedRanks={setPredictedRanks}
              predictedRanks={predictedRanks}
            />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <WhatStudentSay />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <LandJob setShowLoginPrompt={setShowLoginPrompt} />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <LearningPath />
          </MotionDiv>

          <MotionDiv variants={scaleUp}>
            <NeetScore />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <Testimonials />
          </MotionDiv>

          <MotionDiv variants={fadeIn}>
            <LearningSelection />
          </MotionDiv>
          <MotionDiv variants={fadeIn}>
            <HomeFAQs />
          </MotionDiv>
          {/* <FooterFour /> */}
        </MotionDiv>
      </Suspense>
    </>
  );
};

export async function getServerSideProps(context) {
  const authToken = context.req.cookies.authToken || null;
  return {
    props: {
      authToken,
    },
  };
}

export default HomePage;
